/*
 * @Author: zyy
 * @Date: 2022-11-11 17:48:23
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-11 18:31:42
 * @Description: default
 */
import Axios from 'axios';
import Qs from 'qs'

export default {
    list(params) {
        return Axios.get('/community/api/admin/advert/list', {
            params
        })
    },
    add(params) {
        return Axios.post('/community/api/admin/advert/store', params)
    },
    edit(params) {
        return Axios.post(`/community/api/admin/advert/update/${params.id}`, params)
    },
    del(params) {
        return Axios.delete(`/community/api/admin/advert/delete/${params.id}`, params)
    }
}